import React, { Fragment, PureComponent, ReactElement } from 'react';
import { Country } from '~/Api/Country';
import { Product as GeneralProduct } from '~/Api/Product';
import { Product } from '~/Api/User/ProductGroup/LtMaxPrice';

import Header from './Header/Header';
import Row, { EmptyRow, OnChangeListener, OnSelectListener, Values } from './Row';

export interface ProductRow {
	country: Country;
	product: Product | null;
	usedForCalculation: boolean;
}

export type ProductValues = Values;

interface Props {
	disableSelection: boolean;
	highlightProductId: string | null;
	lastSelectedProductId: string | null;
	onChange: OnChangeListener;
	onSelect: OnSelectListener;
	products: ProductRow[];
	productValues: { [key in string]: Values };
	referencePackageSize: number | null;
	referenceDosageStrength: number | null;
	showReferenceDataSource: boolean;
	historicData: boolean;
	detailLink(product: { id: string }): { pathname: string; search: string };
	onSave(): void;
	checkedRows: GeneralProduct[];
	checkRow(product: GeneralProduct, checked: boolean): void;
}

export default class ProductsTable extends PureComponent<Props> {
	public static defaultProps = {
		disableSelection: false,
		showReferenceDataSource: false,
	};

	public render() {
		const { products } = this.props;

		return (
			<Fragment>
				<Header />
				{products.map((optionalProduct) => {
					const { country, product, usedForCalculation } = optionalProduct;
					return product !== null ? (
						this.renderRow(product, usedForCalculation)
					) : (
						<EmptyRow country={country} key={country.alpha2} />
					);
				})}
			</Fragment>
		);
	}

	private renderRow(ltMaxPriceProduct: Product, usedForCalculation: boolean) {
		const {
			productValues,
			referencePackageSize,
			referenceDosageStrength,
			disableSelection,
			showReferenceDataSource,
			highlightProductId,
			lastSelectedProductId,
			historicData,
			detailLink,
			onChange,
			onSelect,
			onSave,
			checkRow,
		} = this.props;
		const { product } = ltMaxPriceProduct;
		const checked = this.props.checkedRows?.some((row) => row.id === product.id);

		return (
			<Row
				detailLink={detailLink}
				disableSelection={disableSelection}
				highlightProduct={highlightProductId === ltMaxPriceProduct.product.id}
				historicData={historicData}
				checked={checked}
				checkRow={(value) => checkRow(product, value)}
				key={product.id}
				lastSelectedProduct={lastSelectedProductId === ltMaxPriceProduct.product.id}
				ltMaxPriceProduct={ltMaxPriceProduct}
				referenceDosageStrength={referenceDosageStrength}
				referencePackageSize={referencePackageSize}
				showReferenceDataSource={showReferenceDataSource}
				usedForCalculation={usedForCalculation}
				values={productValues[product.id]}
				onChange={onChange}
				onSave={onSave}
				onSelect={onSelect}
			/>
		);
	}
}
